module.exports = __webpack_public_path__ + "img/WohinGehts.71dc1b72.jpg";